export default __webpack_public_path__ + "static/media/SndLowerZGoAcross2.898f88be.mp3";